import styled from 'styled-components'

export const Wrapper = styled.div`
  padding-top: 24px;
`

export const Title = styled.div`
  color: #213f68;
  font-size: 18px;
  font-weight: 700;
`

export const Content = styled.div`
  > div + div {
    border-top: 1px solid #d9d9d9;
  }
`

export const MandatoryExtras = styled.div`
  && {
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 16px;
    padding: 0 !important;
    background: transparent !important;
    gap: 8px !important;
    align-items: stretch !important;
    display: flex;
    flex-direction: column;
  }
`

export const NestedSetting = styled.div`
  width: 100% !important;
  padding: 16px 24px;
  border-radius: 8px;
  background-color: #f5f5f5;
  > div {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    align-items: flex-start;
    width: 100% !important;
    margin-top: 0 !important;
    > div:first-child {
      flex: 1;
      min-width: 0;
      span {
        color: #363636;
        font-size: 14px;
        font-weight: 500;
      }
      > div {
        color: #757575;
        font-size: 14px;
        margin-top: 4px;
      }
    }
    .ant-switch {
      flex-shrink: 0;
      align-self: flex-start;
    }
  }
`

export const InfoAlert = styled.div`
  box-sizing: border-box;
  width: 100% !important;
  border: 1px solid #b6dbfb;
  background: #e7f3fe;
  border-radius: 8px;
  padding: 8px;
  font-size: 14px;
  color: #213f68;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  svg {
    color: #213f68;
    margin: 2px 6px 0;
    flex-shrink: 0;
  }
  > div {
    margin-top: 0 !important;
  }
`

export const Option = styled.div`
  > div {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 0;
    > div {
      width: calc(100% - 64px);
      span {
        color: #363636;
        font-size: 14px;
        font-weight: 500;
      }
      > div {
        color: #757575;
        font-size: 14px;
        margin-top: 4px;
      }
    }
  }
  > div[data-evaluation-behavior='retry-panel'] {
    padding: 16px 24px;
    border-radius: 8px;
    background-color: #f5f5f5;
    gap: 39px;
    align-items: center;
    > div {
      color: #363636;
      font-size: 14px;
      font-weight: 500;
      width: calc(100% - 230px);
    }
    > div + div {
      width: 230px;
      input {
        width: 140px;
        height: 40px;
      }
      span {
        color: #757575;
        font-size: 14px;
        font-weight: 700;
        margin-left: 16px;
      }
    }
  }
`
